const Metaspan = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      style={{
        fill: "#fff",
      }}
      d="M0 0h512v512H0z"
    />
    <path
      d="M251.47 64.72c-107.7.55-194.55 88.3-194 196s88.3 194.55 196 194 194.55-88.3 194-196c-.54-106.91-87.08-193.45-194-194Z"
      style={{
        strokeWidth: 26,
        fill: "none",
        stroke: "#010101",
      }}
    />
    <path
      d="M252.47 64.72v390m195-195h-390m44-120a260 260 0 0 0 302 0m0 240a260 260 0 0 0-302 0m136-310C132 158.8 118.68 316.53 207.77 422a250.18 250.18 0 0 0 29.7 29.7m30 0C373 362.63 386.25 204.9 297.16 99.41a250 250 0 0 0-29.69-29.69"
      style={{
        strokeWidth: 18,
        fill: "none",
        stroke: "#010101",
      }}
    />
  </svg>
);

export default Metaspan;
